import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import classes from './PasswordCriteriaHelper.module.css';

const PasswordCriteriaHelper = (props) => {
  const ruleIsMet = (ruleName) => {
    if (ruleName === 'currentPasswordPresent' && props.oldPassword) {
      return props.oldPassword.length > 0;
    }
    if (props.password) {
      if (ruleName === 'eightCharacters') {
        return props.password.length >= 8;
      }
      if (ruleName === 'oneNumber') {
        return /\d/.test(props.password);
      }
      if (ruleName === 'oneUpperCaseLetter') {
        return /[a-z]/.test(props.password);
      }
      if (ruleName === 'oneLowerCaseLetter') {
        return /[A-Z]/.test(props.password);
      }
      if (ruleName === 'oneSpecialCharacter') {
        const specialCharacterFormat = /[ `!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?~]/;
        return specialCharacterFormat.test(props.password);
      }
      if (ruleName === 'passwordConfirmationMatches') {
        return props.password === props.passwordConfirmation;
      }
    }
    return false;
  };
  return (
    <div className={props.disabled ? [classes.PasswordRequirementsHelper, classes.Disabled].join(' ') : classes.PasswordRequirementsHelper}>
      <h3>Password Requirements</h3>
      <div className={classes.Requirements}>
        {props.oldPassword ? (
          <div className={ruleIsMet('currentPasswordPresent') ? [classes.Requirement, classes.Success].join(' ') : classes.Requirement}>
            <FontAwesomeIcon icon={ruleIsMet('currentPasswordPresent') ? 'check-circle' : 'circle'} className={classes.CircleIcon} />
            <p>Current Password Entered</p>
          </div>
        ) : null}
        <div className={ruleIsMet('eightCharacters') ? [classes.Requirement, classes.Success].join(' ') : classes.Requirement}>
          <FontAwesomeIcon icon={ruleIsMet('eightCharacters') ? 'check-circle' : 'circle'} className={classes.CircleIcon} />
          <p>8 or more characters</p>
        </div>
        <div className={ruleIsMet('oneNumber') ? [classes.Requirement, classes.Success].join(' ') : classes.Requirement}>
          <FontAwesomeIcon icon={ruleIsMet('oneNumber') ? 'check-circle' : 'circle'} className={classes.CircleIcon} />
          <p>at least one number</p>
        </div>
        <div
          className={
            ruleIsMet('oneUpperCaseLetter') && ruleIsMet('oneLowerCaseLetter')
              ? [classes.Requirement, classes.Success].join(' ')
              : classes.Requirement
          }
        >
          <FontAwesomeIcon
            icon={ruleIsMet('oneUpperCaseLetter') && ruleIsMet('oneLowerCaseLetter') ? 'check-circle' : 'circle'}
            className={classes.CircleIcon}
          />
          <p>upper & lowercase letters</p>
        </div>
        <div
          className={
            !props.passwordConfirmation || !props.passwordConfirmationTouched
              ? [classes.Requirement, classes.Disabled].join(' ')
              : ruleIsMet('passwordConfirmationMatches')
              ? [classes.Requirement, classes.Success].join(' ')
              : classes.Requirement
          }
        >
          <FontAwesomeIcon icon={ruleIsMet('passwordConfirmationMatches') ? 'check-circle' : 'circle'} className={classes.CircleIcon} />
          <p>password and confirmation match</p>
        </div>
      </div>
    </div>
  );
};

export default PasswordCriteriaHelper;
